// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"d5c7a052cc0aec69","1836":"8a756b8e1e5e35cb","5735":"beb578cc985d134d"}[chunkId] + ".css";
};